module.exports = __webpack_public_path__ + "img/thumbnail-404-outline.aea14bc6.png";